
let APIBASE = process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : window.location.origin
console.log('window.location', window.location)

export default {
   INITIAL_PASSWORD: "usuallyencrypted",

   MEAL_TYPE_LIST: [0, 1, 2, 3, 4, 5, 6],
   MEAL_TYPES: {
      0: { name: "Petit-déjeuner", index: 0, default: true },
      1: { name: "Collation du matin", index: 1, default: false },
      2: { name: "Déjeuner", index: 2, default: true },
      3: { name: "Collation de l'après-midi", index: 3, default: false },
      4: { name: "Dîner", index: 4, default: true },
      5: { name: "Collation du soir", index: 5, default: false },
      6: { name: "Nuit", index: 6, default: false },
   },
   MEAL_SURVEY_LIST: [0, 1, 2],
   MEAL_SURVEYS: {
      0: { name: "Relevé de début de suivi", index: 0 },
      1: { name: "Relevé de suivi intermédiaire", index: 1 },
      2: { name: "Relevé de fin de suivi", index: 2 },
   },

   APIBASE: APIBASE,
   
   PUBLIC_KEY_URL: APIBASE + '/api/get-public-key',
   TOKEN_URL: APIBASE + '/api/api-token-auth',
   ACTIVATE_ACCOUNT_MAIL_URL: APIBASE + '/api/activate-account-mail',
   RESET_PASSWORD_MAIL_URL: APIBASE + '/api/reset-password-mail',
   CREATE_USER_URL: APIBASE + '/api/create-user',
   ACTIVATE_USER_URL: APIBASE + '/api/activate-user',
   INVITE_CAREGIVER_URL: APIBASE + '/api/invite-caregiver',
   ACCEPT_INVITATION_URL: APIBASE + '/api/accept-invitation',

   FITBIT_CLIENT_ID_URL: APIBASE + '/api/fitbit-clientid',
   FITBIT_IS_AUTHORIZED_URL: APIBASE + '/api/fitbit-is-authorized',
   FITBIT_ACCESS_TOKEN_URL: APIBASE + '/api/fitbit-access-token',
   FITBIT_USER_TIME_SERIES_URL: APIBASE + '/api/fitbit-user-time-series',
   

   HTTP_REFERER_URL: APIBASE + '/api/get-http-referer',
   REALMS_URL: APIBASE + '/api/realms/',
   ROLES_URL: APIBASE + '/api/roles/',
   USERS_URL: APIBASE + '/api/users/',
   TEAMS_URL: APIBASE + '/api/teams/',
   COACHED_USERS_URL: APIBASE + '/api/patients/',

   FOODS_URL: APIBASE + '/api/foods/',
   MEALS_URL: APIBASE + '/api/meals/',
   MEAL_ELEMENTS_URL: APIBASE + '/api/meal-elements/',
   FAVORITES_URL: APIBASE + '/api/favorites/',
   FOOD_PORTIONS_URL: APIBASE + '/api/foodportions/',
   FRACTIONNINGS_URL: APIBASE + '/api/fractionnings/',
   NUTRIENTS_URL: APIBASE + '/api/nutrients/',
   NUTDATA_URL: APIBASE + '/api/nutdata/',

   USER_ATTRIBUTES_URL: APIBASE + '/api/user-attributes/',
   USER_ATTRIBUTE_DATED_VALUES_URL: APIBASE + '/api/user-attribute-dated-values/',

   MESSAGES_URL: APIBASE + '/api/messages/',
   HISTORY_EVENT_URL: APIBASE + '/api/history-events/',

   SHDL_MODULES_URL: APIBASE + '/api/shdl-modules/',
   CRAPS_MODULES_URL: APIBASE + '/api/craps-modules/',

   SURVEYS_URL: APIBASE + '/api/surveys/',
   USER_SURVEYS_URL: APIBASE + '/api/user-surveys/',

   QCU_QUESTIONS_URL: APIBASE + '/api/qcuquestions/',
   QCU_IMAGES_URL: APIBASE + '/api/qcuimages/',
   QCU_ITEMS_URL: APIBASE + '/api/qcuitems/',
}




// WEBPACK FOOTER //
// ./src/config/index.js